"use client";

import React from "react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { MapPin, Phone, Mail, Loader2, ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";
export default function ContactForm() {
  return <section data-section-id="33526" id="anmäl-intresse" className="relative bg-background pt-24 pb-0 overflow-hidden border-t border-border">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 pb-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24">
          {}
          <div className="flex flex-col justify-center space-y-12">
            <div>
              <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-foreground mb-6 font-serif">
                Bli en del av nätverket
              </h2>
              <p className="text-muted-foreground text-lg max-w-md font-sans">
                Vi söker engagerade partners som vill växa tillsammans med oss. Som operatör får du tillgång till exklusiva verktyg och ett nätverk som gör verklig skillnad.
              </p>
            </div>

            <div className="space-y-10 font-sans text-sm">
              

              

              <div className="flex items-start space-x-5 group">
                <div className="mt-1 p-3 bg-secondary/50 border border-border rounded-[3px] text-foreground transition-colors group-hover:border-primary group-hover:text-primary">
                  <Mail className="size-5" />
                </div>
                <div>
                  <h3 className="font-medium text-foreground uppercase tracking-wider mb-2 text-xs">E-post</h3>
                  <p className="text-muted-foreground">kontakt@robotaxi.nu</p>
                  
                </div>
              </div>
            </div>
          </div>

          {}
          <div className="bg-card p-8 md:p-10 border border-border shadow-sm relative rounded-[3px]">
            {}
            <div className="absolute top-0 left-0 w-full h-1 bg-primary" />
            
            <div className="mb-8">
              <h3 className="text-2xl font-bold text-foreground font-serif">Skicka en intresseanmälan</h3>
              <p className="text-muted-foreground mt-2 text-sm font-sans">
                Fyll i formuläret nedan så återkommer vi till dig för ett förutsättningslöst samtal.
              </p>
            </div>

            <FormProvider formKey="interest_form_robotaxi" formId="interest_form_robotaxi" sectionName="contact-section" defaultValues={{
            name: "",
            email: "",
            phone: "",
            subject: "",
            message: ""
          }} validationRules={{
            name: {
              required: true
            },
            email: {
              required: true,
              pattern: "email"
            },
            message: {
              required: true
            }
          }} submitText="Skicka intresseanmälan" successMessage="Tack! Vi har tagit emot din anmälan och återkommer inom kort." errorMessage="Något gick fel. Vänligen försök igen senare.">
              <ContactFormContent />
            </FormProvider>
          </div>
        </div>
      </div>

      {}
      <div className="w-full h-16 bg-muted/30 mt-auto" />
    </section>;
}
function ContactFormContent() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center text-center py-12 px-4 space-y-6 bg-secondary/10 border border-border rounded-[3px] animate-in fade-in zoom-in duration-300">
        <div className="size-16 rounded-full bg-primary/10 flex items-center justify-center text-primary mb-2">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="size-8">
            <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
          </svg>
        </div>
        <div>
          <h3 className="text-xl font-bold text-foreground mb-2 font-serif">Anmälan Skickad!</h3>
          <p className="text-muted-foreground max-w-xs mx-auto font-sans">{successMessage}</p>
        </div>
        <Button variant="outline" onClick={() => window.location.reload()} className="mt-4 rounded-[3px] border-border hover:bg-secondary font-sans">
          Skicka en ny anmälan
        </Button>
      </div>;
  }
  const inputClasses = "rounded-[3px] border-input bg-background px-4 py-3 h-auto focus-visible:ring-0 focus-visible:border-primary focus-visible:shadow-[0_0_0_1px_hsl(var(--primary))] transition-all duration-200 placeholder:text-muted-foreground/60 font-sans";
  const labelClasses = "text-[14px] font-medium uppercase tracking-wider text-muted-foreground mb-2 ml-1 font-sans";
  return <Form onSubmit={handleSubmit} className="space-y-6">
      <FormField control={control} name="name" rules={{
      required: "Namn är obligatoriskt"
    }} render={({
      field
    }) => <FormItem className="space-y-1">
            <FormLabel className={labelClasses}>Namn <span className="text-primary">*</span></FormLabel>
            <FormControl>
              <Input placeholder="Ditt fullständiga namn" {...field} className={inputClasses} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField control={control} name="email" rules={{
        required: "E-post är obligatoriskt",
        pattern: {
          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
          message: "Ogiltig e-postadress"
        }
      }} render={({
        field
      }) => <FormItem className="space-y-1">
              <FormLabel className={labelClasses}>E-post <span className="text-primary">*</span></FormLabel>
              <FormControl>
                <Input type="email" placeholder="namn@foretag.se" {...field} className={inputClasses} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="phone" render={({
        field
      }) => <FormItem className="space-y-1">
              <FormLabel className={labelClasses}>Ort</FormLabel>
              <FormControl>
                <Input type="text" placeholder="Stad eller region" {...field} className={inputClasses} />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <FormField control={control} name="subject" render={({
      field
    }) => <FormItem className="space-y-1">
            <FormLabel className={labelClasses}>Ärende</FormLabel>
            <FormControl>
              <Input placeholder="Kort beskrivning av ditt intresse" {...field} className={inputClasses} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="message" rules={{
      required: "Meddelande är obligatoriskt"
    }} render={({
      field
    }) => <FormItem className="space-y-1">
            <FormLabel className={labelClasses}>Meddelande <span className="text-primary">*</span></FormLabel>
            <FormControl>
              <textarea className={cn("flex min-h-[150px] w-full border border-input bg-background px-4 py-3 text-sm shadow-xs placeholder:text-muted-foreground/60 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 resize-y", "rounded-[3px] focus-visible:border-primary focus-visible:shadow-[0_0_0_1px_hsl(var(--primary))] transition-all duration-200 font-sans")} placeholder="Berätta lite om din verksamhet..." {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="p-4 text-sm text-destructive bg-destructive/5 border border-destructive/20 rounded-[3px] flex items-center gap-2 font-sans">
          <span className="font-bold">Fel:</span> {submitError}
        </div>}

      <Button type="submit" disabled={isSubmitting} className="w-full rounded-[3px] bg-primary hover:bg-primary/90 text-primary-foreground font-bold tracking-wide h-14 text-base shadow-md transition-all duration-300 mt-2 font-sans">
        {isSubmitting ? <>
            <Loader2 className="mr-2 size-5 animate-spin" />
            SKICKAR...
          </> : <span className="flex items-center gap-2">
            SKICKA INTRESSEANMÄLAN <ArrowRight className="size-4" />
          </span>}
      </Button>
    </Form>;
}